<div class="box-loading" *ngIf="this.carregado">
  
  <div class="box-loading__content">

    <div class="box-loading__content__caurosel" *ngIf="!this.responseOrder.sucess && !this.responseOrder.error">

      <!--Delivery e balcão-->
      <ng-container *ngIf="this.typeOrder == 1">
        <!-- <div>
          <img [src]="currentImage" style="width: 100%;" alt="Imagem">
        </div> -->

        <div class="box-logo">
          <img [src]="this.company.company.logo" class="logo-company" style="width: 170px; height: 170px; object-fit: cover;">
        </div>

        <!--Loading-->
        <div class="loader">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <span style="text-align: center; font-weight: 600; margin-top: 30px; color: var(--primary-color);">Carregando...</span>

        <span class="text">{{ this.textExibing }}</span>

      </ng-container>

      <!--Local-->
      <ng-container *ngIf="this.typeOrder == 2">

        <!--Logo-->
        <div class="box-logo">
          <img [src]="this.company.company.logo" class="logo-company">
        </div>

        <!--Loading-->
        <div class="loader">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>

        <!--Textos-->
        <span class="text">{{ this.textExibing }}</span>

        <!--Contador-->
        <div>
          <app-counter-cancelled-consumption></app-counter-cancelled-consumption>
        </div>

        <!--Mensagem-->
        <div class="text-info-warn">
          <span>Se o pedido não for confirmado dentro de 3 minutos, ele será cancelado automaticamente.</span>
        </div>

      </ng-container>

    </div>

    <!--Pedido feito com sucesso-->
    <div *ngIf="this.responseOrder.sucess == true" class="success-container">
      
      <!-- Header with Icon & Check -->
      <div class="box-checked">
        <div class="icon-check check"></div>
        <h2 class="success-text">Pedido realizado com sucesso!</h2>
      </div>

      <ng-container *ngIf="this.responseOrder.order && this.responseOrder.order.cashbackValue > 0">
        <div class="cashback-celebration-card">
          <div class="icone-part">
            <div class="icon-wallet"></div>
          </div>
          <div class="text-part">
            <span class="congrats-title">Parabéns!</span>
            <span class="congrats-msg">Você ganhou <strong>{{ this.responseOrder.order.cashbackValue | currency:'BRL' }}</strong> de cashback neste pedido</span>
          </div>
        </div>
      </ng-container>

      <div class="button-bottom" *ngIf="this.responseOrder.order && this.responseOrder.order.cashbackValue > 0">
        <button class="button" (click)="goToOrders()">
          Ver Pedido ({{ this.counter }})
        </button>
      </div>

    </div>

    <!--Erro ao emitir pedido-->
    <div *ngIf="this.responseOrder.error == true">

      <div class="box-error">
        <div class="icon-thumbs-down error"></div>
        <span style="padding-left: 20px; padding-right: 20px; text-align: center; color: #dd0000; font-size: 19px; font-weight: 600;">Ops! Não foi possivel processar seu pedido. Procure um atendente para auxiliá-lo.</span>
      </div>

      <div class="button-bottom" *ngIf="this.responseOrder.error == true">
        <button class="button" (click)="redirect()">Ok, entendi</button>
      </div>
      
    </div>

  </div>

</div>
